module.exports = __webpack_public_path__ + "img/teacat_img_shop_notchoose.96fdd521.png";